var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1467 26.8023H1V1H27.6253V20.7184",
    stroke: "#FCFAFA",
    strokeWidth: 1.34525,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1751 19.7118C11.5036 19.4416 10.9671 19.0413 10.5653 18.5113C10.1635 17.9815 9.95166 17.3433 9.92969 16.597H12.9346C12.9785 17.0188 13.1271 17.3407 13.3804 17.5622C13.6335 17.784 13.9637 17.8948 14.371 17.8948C14.7893 17.8948 15.1195 17.8003 15.3617 17.6109C15.6037 17.4218 15.7249 17.1595 15.7249 16.8241C15.7249 16.543 15.6285 16.3105 15.4361 16.1265C15.2433 15.9427 15.0067 15.7915 14.726 15.6723C14.4454 15.5534 14.0462 15.4183 13.529 15.2667C12.7804 15.0396 12.1695 14.8125 11.6964 14.5853C11.223 14.3583 10.8157 14.0231 10.4746 13.5795C10.1334 13.1362 9.96281 12.5575 9.96281 11.8437C9.96281 10.7839 10.3534 9.95376 11.135 9.35347C11.9165 8.75324 12.9347 8.45312 14.1895 8.45312C15.4663 8.45312 16.4954 8.75324 17.277 9.35347C18.0584 9.95376 18.4766 10.7892 18.5318 11.8599H15.4773C15.4552 11.4924 15.3177 11.2029 15.0645 10.992C14.8112 10.7811 14.4866 10.6757 14.0904 10.6757C13.7491 10.6757 13.4738 10.7649 13.2648 10.9433C13.0556 11.1217 12.9511 11.3788 12.9511 11.7139C12.9511 12.0817 13.127 12.3684 13.4795 12.5737C13.8316 12.7793 14.3818 13.0011 15.1306 13.2389C15.8789 13.4878 16.4869 13.7256 16.9549 13.9527C17.4227 14.1798 17.8271 14.5099 18.1685 14.9423C18.5095 15.375 18.6803 15.9319 18.6803 16.6133C18.6803 17.2622 18.5123 17.8518 18.1767 18.3816C17.8409 18.9116 17.3537 19.3335 16.7155 19.647C16.077 19.9608 15.323 20.1174 14.4536 20.1174C13.6058 20.1174 12.8463 19.9823 12.1751 19.7119L12.1751 19.7118Z",
    fill: "#FCFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8743 22.2344H22.6484V27.3674H24.8743V22.2344Z",
    fill: "#FCFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2064 22.2344H22.6484V24.3252H28.2064V22.2344Z",
    fill: "#FCFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8874 22.9532L23.3828 24.4316L27.4972 28.4744L29.0019 26.996L24.8874 22.9532Z",
    fill: "#FCFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.23dc7ba5891e0567d125328ca6e84c11.svg";
export { ForwardRef as ReactComponent };